import React from 'react';
import Texts from '../../../assets/utils/texts';
import Icons from 'components/atoms/Icons';
import Modal from 'assets/shared/Modal';
import ProviderNextAvailable from './ProviderNextAvailable';
import { LocationItem } from 'components/types/LocationTypes';

type ProviderLocationProps = {
	index: number;
	location: LocationItem;
	providerId: string;
	providerName: string;
	ksb?: boolean;
	deptDays?: { [key: string]: string[] };
	userDistance?: any;
};

const ProviderLocation = (props: ProviderLocationProps): JSX.Element => {
	const { index, location, providerId, providerName, ksb, deptDays, userDistance } = props;
	return (
		<div className="provider-location">
			<div className="inner-section">
				<div className="location-top-row">
					<div className="location-info">
						{index == 0 ? (
							<p className="primary-location-head">{Texts.PrimaryLocation}</p>
						) : (
							<p className="other-location-head">Other Location(s)</p>
						)}

						<div
							className="location-address"
							data-module="LocationMap"
							data-coords={`${parseFloat(location?.fields?.Latitude?.value)}, ${parseFloat(
								location?.fields?.Longitude?.value
							)}`}
							itemScope
							itemProp="hospitalAffiliation"
							itemType="http://schema.org/Hospital"
						>
							<div className="location-heading-wrapper">
								<h3 className="location-name" itemProp="name">
									{`${index + 1}. ${location?.fields?.LocationName?.value}`}
								</h3>
							</div>
							<p>{userDistance}</p>
							<div className="location-details-wrapper">
								<div className="left-col">
									<a
										className="address"
										itemProp="address"
										itemScope
										itemType="http://schema.org/PostalAddress"
										href={`https://maps.apple.com/?daddr=${location?.fields?.Street1?.value.replaceAll(
											' ',
											'+'
										)},${location?.fields?.City?.value},${location?.fields?.State?.value}`}
										target="_blank"
									>
										<div className="top-wrapper">
											<Icons id="location" className="section-icon" aria-hidden="true" />
											<p itemProp="streetAddress">
												<span className="street-name">{location?.fields?.Street1?.value}</span>
												<span>{` ${location?.fields?.Suite?.value}`}</span>
											</p>
										</div>
										<p itemProp="addressLocality">
											{location?.fields?.City?.value}
											<span itemProp="addressRegion">, {location?.fields?.State?.value}</span>
											<span itemProp="postalCode">{` ${location?.fields?.Zip?.value}`}</span>
										</p>
									</a>
									<div className="phone">
										<Icons id="phone" className="section-icon" aria-hidden="true" />
										<a
											className="phone"
											itemScope
											itemType="http://schema.org/Hospital"
											href={`tel:${location?.fields?.Phone?.value}`}
											itemProp="telephone"
										>
											{location?.fields?.Phone?.value}
										</a>
									</div>
									<div className="details">
										<Icons id="external" className="section-icon" aria-hidden="true" />
										<a
											className="details-link"
											href={location?.fields?.FormattedUrl?.value}
											target="_blank"
											rel="noopener noreferrer"
										>
											Location Details
										</a>
									</div>
								</div>
								<div className="right-col">
									<ProviderNextAvailable
										deptDays={deptDays}
										deptId={location?.fields?.EpicDeptId?.value}
										providerId={providerId}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
				{ksb && <div className="ksb-provider"></div>}
				{(deptDays && deptDays[location?.fields?.EpicDeptId?.value]?.length > 0) || ksb ? (
					<div className="has-online-appointment">
						<Modal
							customClass="modal scheduling-modal location"
							openBtnClass="btn-primary schedule-btn"
							openBtnLabel="Schedule Online"
							portalId="provider-location-modal-root"
						>
							<div className="modal-details">
								<h2>{providerName}</h2>
								<p className="subtitle">New Patient Appointment</p>
								<p className="location-label">Location</p>
								<div className="schedule-location">
									<div className="selector">
										<p className="scheduling-modal-location">
											{location?.fields?.City?.value}: {location?.fields?.LocationName?.value}
										</p>
									</div>
								</div>
							</div>
							<div className="mychart-container">
								{ksb ? (
									<iframe
										className="schedule-frame"
										src={location?.fields?.BookOnlineOverrideUrl?.value}
										frameBorder="0"
										allowFullScreen
										tabIndex={0}
										data-ksb={ksb}
									></iframe>
								) : (
									<iframe
										src={`https://www.osfmychart.org/OSFMyChart/openscheduling/SignupAndSchedule/EmbeddedSchedule?vt=1003&id=${providerId}&dept=${location?.fields?.EpicDeptId?.value}&linksource=directory`}
										frameBorder="0"
										allowFullScreen
										tabIndex={0}
									></iframe>
								)}
							</div>
						</Modal>
					</div>
				) : (
					<div className="no-online-appointment">
						<a href={`tel:${location?.fields?.Phone?.value}`} className="btn-primary">
							Call to Schedule
						</a>
						<p className="not-available">Online scheduling not available for this location.</p>
					</div>
				)}
			</div>
		</div>
	);
};

export default ProviderLocation;
